import {useOptionalMeasurementEditor, useOptionalOneOfEditor} from "../pages/selection/useFanCriteria";
import {WentechMeasuringStandards} from "../business/measurement/WentechMeasurementStandards";
import {ShaftLengthBonusElements} from "./ShaftLengthBonusElements";
import React, {useEffect} from "react";
import {SimulationRequestJson} from "../business/ApiJsonTypes";
import {OptionalEditor} from "../form/editors/OptionalEditor";
import {MeasureEditorValue} from "../form/editors/MeasureEditor";


export function useShaftDimensionsEditors(
    availableShaftDiameters: number[],
    predefinedCriteria: SimulationRequestJson | null,
    useLastShaftDiameterWhenUnAutoselected: () => any = () => {},
    useLastShaftLengthWhenUnAutoselected: () => any = () => {},
    useLastScrewMWhenUnAutoselected: () => any = () => {},

): {
    shaftDiameterEditor: OptionalEditor<string>;
    shaftLengthEditor: OptionalEditor<MeasureEditorValue>;
    screwMEditor: OptionalEditor<MeasureEditorValue>;
    threadLengthEditor: OptionalEditor<MeasureEditorValue>
} {
    const shaftDiameterEditor = useOptionalOneOfEditor(availableShaftDiameters.map(asd => ({key: "" + asd, label: asd + " mm"})), "" + availableShaftDiameters[0], false,
        useLastShaftDiameterWhenUnAutoselected);
    const shaftLengthEditor = useOptionalMeasurementEditor(
        WentechMeasuringStandards.SHAFT_LENGTH,
        false,
        (editor) => <ShaftLengthBonusElements editor={editor} shaftDiameterEditor={shaftDiameterEditor} onCommonShaftsDiscovered={onDiscoveryOfCommonShaftLengthsForDiameter}/>,
        false,
        useLastShaftLengthWhenUnAutoselected);
    const screwMEditor = useOptionalMeasurementEditor(
        WentechMeasuringStandards.SCREW_M,
        false, undefined, false, useLastScrewMWhenUnAutoselected);
    const threadLengthEditor = useOptionalMeasurementEditor(
        WentechMeasuringStandards.SHAFT_THREAD_LENGTH,
        false, undefined, true);

    const onDiscoveryOfCommonShaftLengthsForDiameter = (lengths: number[]) => {
        if (shaftLengthEditor.enabled && shaftLengthEditor.value != null && shaftLengthEditor.value < lengths[0]) {
            shaftLengthEditor.populate(lengths[0]);
        }
    }

    useEffect(() => {
        if ( screwMEditor.enabled) {
            threadLengthEditor.enable();
        } else {
            threadLengthEditor.disable();
        }
    }, [screwMEditor.enabled]);

    useEffect(function preopopulate() {
        if (predefinedCriteria == null) {
            return;
        }
        const mechanicalPrefs = predefinedCriteria.mechanicalPreferences;
        if (mechanicalPrefs.shaftDiameter != null) {
            shaftDiameterEditor.populate(mechanicalPrefs.shaftDiameter.toString())
            shaftDiameterEditor.enable();
        }
        if (mechanicalPrefs.shaftLength != null) {
            shaftLengthEditor.populate(mechanicalPrefs.shaftLength)
            shaftLengthEditor.enable();
        }
        if (mechanicalPrefs.customShaftThreadPreference != null) {
            screwMEditor.populate(mechanicalPrefs.customShaftThreadPreference.customScrewM);
            threadLengthEditor.populate(mechanicalPrefs.customShaftThreadPreference.customDlugoscGwintuWCzopieWalu);
            screwMEditor.enable();
            threadLengthEditor.enable();
        }
    }, []); // Expected to be run only once when conifgurator is instantiated

    return {
        shaftDiameterEditor,
        shaftLengthEditor,
        screwMEditor,
        threadLengthEditor
    }

}